export default __webpack_public_path__ + "static/media/playIcon.3444cd27.svg";